/**
 * Birthday Gift Drop progress bars (CNV-3174).
 *
 * Parallel components behind the birthday_gift_enabled kill switch — the stock
 * bars are never edited, only hidden. Tier maths comes from the CNV-3010
 * module's read-only export (window.BirthdayGiftDrop), so a bar can never
 * promise a gift the cart logic would not add.
 *
 * Triggers: `mozi:cart:updated` (sidecart's settled-cart event) for the cart
 * bar, `mozi:bundle:progress` for the builder. No polling, no timers.
 */
(function () {
  'use strict';

  if (window.__birthdayProgressBar) return;
  window.__birthdayProgressBar = true;

  function readCopy(surface) {
    var el = document.querySelector('script[data-birthday-copy="' + surface + '"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // Blank settings fall back to the previous state's message rather than
  // rendering an empty bar.
  function pick(list, state) {
    if (!list) return '';
    for (var i = Math.min(state, list.length - 1); i >= 0; i--) {
      if (list[i] && String(list[i]).replace(/<[^>]*>/g, '').trim()) return list[i];
    }
    return '';
  }

  // A surface can render at several include sites (the bundle bar appears in
  // the subscription box, sticky bar and mobile sticky), so every root is
  // driven together.
  function makeSurface(surface, positions) {
    var roots = document.querySelectorAll('[data-birthday-progress="' + surface + '"]');
    var copy = readCopy(surface);
    if (!roots.length || !copy) return null;

    return {
      render: function (itemCount, hasSubscription, thresholds) {
        // state = how many real tiers this count has reached (0..4)
        var state = 0;
        for (var i = 0; i < thresholds.length; i++) {
          if (itemCount >= thresholds[i]) state++;
        }
        var max = state >= thresholds.length && thresholds.length > 0;

        for (var r = 0; r < roots.length; r++) {
          var root = roots[r];
          var tierBadge = root.querySelector('[data-birthday-badge-tier]');
          var subBadge = root.querySelector('[data-birthday-badge-sub]');
          var message = root.querySelector('[data-birthday-message]');
          var subtitle = root.querySelector('[data-birthday-subtitle]');
          var fill = root.querySelector('[data-birthday-fill]');
          var markers = root.querySelectorAll('[data-birthday-marker]');

          if (tierBadge) {
            tierBadge.textContent = max
              ? copy.badge_max || ''
              : (copy.badges && copy.badges[state]) || '';
            // The green max treatment is the cart drawer's; the bundle badge
            // stays pink (max_style: false in its copy blob).
            var maxStyle = max && copy.max_style !== false;
            tierBadge.classList.toggle('birthday-progress__badge--max', maxStyle);
            tierBadge.classList.toggle('birthday-progress__badge--tier', !maxStyle);
          }
          if (subBadge) subBadge.style.display = hasSubscription ? '' : 'none';

          var column = hasSubscription ? copy.sub : copy.otp;
          if (message) message.innerHTML = pick(column, state);
          if (subtitle) {
            var subColumn = hasSubscription ? copy.sub_subtitles : copy.otp_subtitles;
            subtitle.innerHTML = pick(subColumn, state);
          }

          if (fill) {
            var width = 0; // empty state is an all-grey track, as designed
            if (max) width = 100;
            else if (state > 0) width = positions[state - 1];
            fill.style.width = width + '%';
          }

          for (var m = 0; m < markers.length; m++) {
            markers[m].classList.toggle('is-reached', m < state);
          }
        }
      }
    };
  }

  var cartBar = null;
  var bundleBar = null;

  /**
   * The stock bars are hidden from first paint (`birthday-bars`, set inline in
   * sidecart.liquid) so the pre-birthday bar never flashes; if the gift module
   * did not come up, hand them straight back.
   *
   * Must wait for DOMContentLoaded: this script is rendered BEFORE the gift
   * module in theme.liquid and deferred scripts run at readyState
   * 'interactive', so judging the module inline would always find it missing
   * and release the stock bars into a double-bar state.
   */
  function releaseStockBars() {
    document.documentElement.classList.remove('birthday-bars');
  }

  function checkModule() {
    var api = window.BirthdayGiftDrop;
    if (!api || !api.thresholds || !api.thresholds.length) releaseStockBars();
  }

  if (document.readyState === 'complete') {
    checkModule();
  } else {
    document.addEventListener('DOMContentLoaded', checkModule);
  }

  // Cart drawer: the settled cart is in the event; the module does the maths.
  document.addEventListener('mozi:cart:updated', function (event) {
    var api = window.BirthdayGiftDrop;
    var cart = event && event.detail && event.detail.cart;
    if (!api || !cart) return;

    if (!cartBar) cartBar = makeSurface('cart', [10, 36.7, 63.3, 90]);
    if (!cartBar) return;

    var summary = api.summarise(cart);
    if (!summary.thresholds.length) return;
    cartBar.render(summary.itemCount, summary.hasSubscription, summary.thresholds);
    document.body.classList.add('birthday-cart-bar-active');
  });

  // Bundle builder: selections are not cart lines yet; every builder item
  // counts as 1 (individual tins/mists), thresholds still the module's.
  document.addEventListener('mozi:bundle:progress', function (event) {
    var api = window.BirthdayGiftDrop;
    var detail = event && event.detail;
    if (!api || !detail) return;

    if (!bundleBar) bundleBar = makeSurface('bundle', [6.5, 35.5, 64.5, 93.5]);
    if (!bundleBar) return;

    var thresholds = api.thresholds || [];
    if (!thresholds.length) return;
    var count = (detail.nonMistQty || 0) + (detail.mistQty || 0);
    bundleBar.render(count, !!detail.isSubscriptionMode, thresholds);
    document.body.classList.add('birthday-bundle-bar-active');
  });
})();
